import { Component, OnInit, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { PaymentCustomerService } from '../../../providers/payment-customer.service';
import { PaymentCardService } from '../../../providers/payment-card.service';
import { faSave, faCreditCard, faPlus, faUser } from '@fortawesome/pro-regular-svg-icons';
import { SmsAbstractAppPage } from '../../sms-abstract-app-page';
import { Braintree_credit_card } from '../../../models/accounting/banking/braintree_credit_card';
import { Braintree_customer } from '../../../models/accounting/banking/braintree_customer';

@Component({
  standalone: false,
  selector: 'app-modal-add-credit-card-method',
  templateUrl: './modal-add-credit-card.component.html',
styleUrls:  ['./modal-add-credit-card.component.css']
})
export class ModalAddCreditCardComponent extends SmsAbstractAppPage implements OnInit {

  faSave = faSave;
  faCreditCard = faCreditCard;
  faPlus = faPlus;
  faUser = faUser;

  card_model: Card_model = new Card_model();
  submitting: boolean = false;
  card_added$: EventEmitter<Braintree_credit_card> = new EventEmitter<Braintree_credit_card>();
  display_add_customer: boolean = false;
  sms_customer_list: Braintree_customer[] = [];
  selected_customer: Braintree_customer = new Braintree_customer({system_customer_id: null});

  constructor(public activeModal: NgbActiveModal, private paymentCustomerService: PaymentCustomerService, private paymentCardService: PaymentCardService) {
    super();
  }

  ngOnInit() {
    this.paymentCustomerService.get_list().then(customer_list => {
      this.sms_customer_list.push(this.selected_customer);
      customer_list.forEach((customer, i) => {
        this.sms_customer_list.push(customer);
      });

    }).catch(error => {
      this.handleError(error);
    });
  }

  onSubmit(){

    this.submitting = true;

        let validation_errors: String[] = [];

    if(!this.selected_customer.hasOwnProperty('customer_id') || this.selected_customer.customer_id == null || this.selected_customer.customer_id == ''){
          validation_errors.push("Customer ID must have a value");
        }

        if(this.card_model.cardholder_name == ''){
          validation_errors.push("Cardholder name must have a value!");
        }

        if(this.card_model.card_number == ''){
          validation_errors.push("Card # must have a value!");
        }

        if(this.card_model.cvv == ''){
          validation_errors.push("CVV must have a value!");
        }

        if(this.card_model.month == ''){
          validation_errors.push("Month must have a value!");
        }

    if(this.card_model.year == ''){
          validation_errors.push("Year must have a value!");
        }

        if(this.card_model.postal_code == ''){
          validation_errors.push("Postal code must have a value!");
        }

        if(this.card_model.country == ''){
          validation_errors.push("Country must have a value!");
        }

        if(validation_errors.length > 0){
        validation_errors.forEach((error, i) => {
          this.handleError(error);
        });
        return;
      }

      this.card_model.customer_id = this.selected_customer.customer_id;
      this.card_model.system_customer_id = this.selected_customer.system_customer_id;
      this.card_model.first_name = this.selected_customer.first_name;
      this.card_model.last_name = this.selected_customer.last_name;

    this.paymentCardService.create(this.card_model).then(card => {

      this.card_added$.emit(card);

       }).catch(error => {
           this.submitting = false;
           this.handleError(error);
       });

  }

  handleAddCustomer(customer: Braintree_customer) {
    this.display_add_customer = false;
    this.sms_customer_list.push(customer);
    this.card_model.cardholder_name = customer.first_name + " " + customer.last_name;
    this.selected_customer = customer;
  }

  handleCustomerChange(event: any){
    if(this.selected_customer.hasOwnProperty('system_customer_id')){
      this.card_model.cardholder_name = this.selected_customer.first_name + " " + this.selected_customer.last_name;
    }
  }

}

class Card_model {

  customer_id: string;
  system_customer_id: string;
  cardholder_name: string;
  card_number:  string;
  cvv:  string;
  month: string;
  year:  string;
  postal_code:  string;
  first_name: string;
  last_name: string;
  country: string;

  constructor() {
    this.customer_id = null;
    this.system_customer_id = null;
    this.cardholder_name = '';
    this.card_number = '';
    this.cvv = '';
    this.month = '';
    this.year = '';
    this.postal_code = '';
    this.country = 'US';
    this.first_name = '';
    this.last_name = '';
  }

}
